import { render } from "./phoneCode.vue?vue&type=template&id=a3be8aaa&scoped=true&ts=true"
import script from "./phoneCode.vue?vue&type=script&lang=ts"
export * from "./phoneCode.vue?vue&type=script&lang=ts"

import "./phoneCode.vue?vue&type=style&index=0&id=a3be8aaa&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3be8aaa"]])

export default __exports__